import { Request } from "@/data/Requests"

async function GetIdentity() {
  return await Request(`/identity`, {
    method: "GET",  
  })
}

export default {
  GetIdentity,
}